export default "__VITE_ASSET__d6c52fc4__"